var render, staticRenderFns
import script from "./SupportPointLabel.vue?vue&type=script&lang=ts"
export * from "./SupportPointLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c8e1c0')) {
      api.createRecord('07c8e1c0', component.options)
    } else {
      api.reload('07c8e1c0', component.options)
    }
    
  }
}
component.options.__file = "src/components/Viewer/Labels/SupportPointLabel.vue"
export default component.exports